import React from 'react';
import { Link } from 'react-router-dom';
import StatusBadge from '../../../components/status/StatusBadge';
import RiskBadge from '../../../components/status/RiskBadge';
import { OPERATION_TYPES_LABELS } from '../../../constants/operationTypes';
import { FileText, Building, Briefcase, Landmark, Flame, AlertCircle } from 'lucide-react';
import Tooltip from "../../../components/ui/Tooltip";
import { motion } from 'framer-motion';

export default function DossierCard({ dossier }) {
 const typeLabel = OPERATION_TYPES_LABELS[dossier.operationType] || dossier.operationType;
 const demandeur = dossier.famille?.nom || dossier.societe?.denomination || 'Non renseigné';
 
 const getOperationIcon = (type) => {
 switch (type) {
 case 'REAL_ESTATE_CLUB_DEAL':
 case 'REAL_ESTATE_VALUE_ADD':
 case 'REAL_ESTATE_CORE':
 return <Building className="w-5 h-5 text-primary" />;
 case 'PRIVATE_EQUITY_LBO':
 case 'PRIVATE_EQUITY_GROWTH':
 case 'PRIVATE_EQUITY_MBO':
 return <Briefcase className="w-5 h-5 text-primary" />;
 case 'INFRASTRUCTURE':
 return <Landmark className="w-5 h-5 text-primary" />;
 case 'VENTURE_CAPITAL':
 return <Flame className="w-5 h-5 text-primary" />;
 default:
 return <Briefcase className="w-5 h-5 text-primary" />;
 }
 };

 return (
 <motion.div 
 whileHover={{ y: -4 }}
 className="workspace-card flex flex-col h-full overflow-hidden transition-shadow hover:shadow-hp-md relative"
 >
 {dossier.alerts?.length > 0 && (
 <Tooltip content={`${dossier.alerts.length} élément(s) requérant votre attention`}>
 <div 
 className="absolute top-3 right-3 flex items-center justify-center bg-danger-100 text-danger-700 rounded-full px-2 py-0.5 text-xs font-bold border border-danger-200 z-10 shadow-sm cursor-help"
 >
 <AlertCircle className="w-3 h-3 mr-1" />
 {dossier.alerts.length}
 </div>
 </Tooltip>
 )}
 
 <div className="p-5 flex-1 mt-2">
 <div className="flex justify-between items-start mb-4">
 <div className="flex items-center gap-3">
 <div className="p-2 bg-primary-light rounded-lg">
 {getOperationIcon(dossier.operationType)}
 </div>
 <div>
 <div className="text-xs font-semibold text-tertiary">{dossier.reference}</div>
 <p className="text-xs text-primary font-medium">{typeLabel}</p>
 </div>
 </div>
 </div>
 
 <h3 className="text-lg font-bold text-primary mb-4 truncate">
 <Tooltip content={dossier.title}>
 <Link to={`/forum/${dossier.id}`} className="hover:text-secondary">{dossier.title}</Link>
 </Tooltip>
 </h3>
 
 <div className="space-y-2 mb-4">
 <div className="flex justify-between text-sm">
 <span className="text-muted">Demandeur</span>
 <span className="font-medium text-primary">{demandeur}</span>
 </div>
 <div className="flex justify-between text-sm">
 <span className="text-muted">Montant</span>
 <span className="font-medium text-primary">
 {dossier.requestedAmount ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: dossier.currency || 'EUR' }).format(dossier.requestedAmount) : 'N/C'}
 </span>
 </div>
 <div className="flex justify-between text-sm">
 <span className="text-muted">Lieu</span>
 <span className="font-medium text-primary truncate max-w-[120px]">{dossier.location || 'N/C'}</span>
 </div>
 </div>
 </div>
 
 <div className="bg-surface-muted px-5 py-3 border-t border-workspace flex justify-between items-center text-xs">
 <div className="flex items-center space-x-3">
 <StatusBadge status={dossier.status} type="dossier" />
 {dossier.riskLevel && <RiskBadge level={dossier.riskLevel} />}
 </div>
 <div className="flex items-center space-x-4">
 <Tooltip content="Documents associés">
 <span className="text-tertiary flex items-center">
 <FileText className="w-4 h-4 mr-1" />
 {dossier.documents?.length || 0}
 </span>
 </Tooltip>
 <Tooltip content={`Assigné à ${dossier.assignedUser?.Nom || 'Non assigné'}`}>
 <div className="text-tertiary font-medium truncate max-w-[100px]">
 {dossier.assignedUser?.Nom || 'Non assigné'}
 </div>
 </Tooltip>
 </div>
 </div>
 </motion.div>
 );
}
